// extracted by mini-css-extract-plugin
export default {"tipInput":"TipInput_tipInput__OCWUu"};